module.exports = __webpack_public_path__ + "static/media/c2-bg.bb2ec07e.jpg";